import { render, staticRenderFns } from "./PaymentDenied.vue?vue&type=template&id=64e557a3&scoped=true"
import script from "./PaymentDenied.vue?vue&type=script&lang=js"
export * from "./PaymentDenied.vue?vue&type=script&lang=js"
import style0 from "./PaymentDenied.vue?vue&type=style&index=0&id=64e557a3&prod&lang=scss&scoped=true"
import style1 from "./PaymentDenied.vue?vue&type=style&index=1&id=64e557a3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64e557a3",
  null
  
)

export default component.exports